import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'te',
  months: [
    'జనవరి',
    'ఫిబ్రవరి',
    'మార్చి',
    'ఏప్రిల్',
    'మే',
    'జూన్',
    'జులై',
    'ఆగస్టు',
    'సెప్టెంబర్',
    'అక్టోబర్',
    'నవంబర్',
    'డిసెంబర్',
  ],
  monthsShort: ['జన', 'ఫిబ్ర', 'మార్చి', 'ఏప్రి', 'మే', 'జూన్', 'జులై', 'ఆగ', 'సెప్టెం', 'అక్టో', 'నవం', 'డిసెం'],
  weekdays: ['ఆదివారం', 'సోమవారం', 'మంగళవారం', 'బుధవారం', 'గురువారం', 'శుక్రవారం', 'శనివారం'],
  weekdaysMin: ['ఆ', 'సో', 'మ', 'బు', 'గు', 'శు', 'శ'],
  weekdaysShort: ['ఆది', 'సోమ', 'మంగళ', 'బుధ', 'గురు', 'శుక్ర', 'శని'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM, YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM, YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, h:mm A',
    'lll-Y': 'D MMM, h:mm A',
    llll: 'ddd, D MMM YYYY, h:mm A',
    'llll-Y': 'ddd, D MMM, h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM, YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s సం. క్రితం', other: '%s సం. క్రితం' },
    M: { one: '%s నెల క్రితం', other: '%s నెలల క్రితం' },
    w: { one: '%s వారం క్రితం', other: '%s వారాల క్రితం' },
    d: { one: '%s రోజు క్రితం', other: '%s రోజుల క్రితం' },
    h: { one: '%s గం. క్రితం', other: '%s గం. క్రితం' },
    m: { one: '%s నిమి. క్రితం', other: '%s నిమి. క్రితం' },
    s: { one: '%s సెక. క్రితం', other: '%s సెక. క్రితం' },
  },
  future: {
    y: { one: '%s సం.లో', other: '%s సం.ల్లో' },
    M: { one: '%s నెలలో', other: '%s నెలల్లో' },
    w: { one: '%s వారంలో', other: '%s వారాల్లో' },
    d: { one: '%s రోజులో', other: '%s రోజుల్లో' },
    h: { one: '%s గం.లో', other: '%s గం.లో' },
    m: { one: '%s నిమి.లో', other: '%s నిమి.లో' },
    s: { one: '%s సెకనులో', other: '%s సెకన్లలో' },
  },
  pastLong: {
    y: { one: '%s సంవత్సరం క్రితం', other: '%s సంవత్సరాల క్రితం' },
    M: { one: '%s నెల క్రితం', other: '%s నెలల క్రితం' },
    w: { one: '%s వారం క్రితం', other: '%s వారాల క్రితం' },
    d: { one: '%s రోజు క్రితం', other: '%s రోజుల క్రితం' },
    h: { one: '%s గంట క్రితం', other: '%s గంటల క్రితం' },
    m: { one: '%s నిమిషం క్రితం', other: '%s నిమిషాల క్రితం' },
    s: { one: '%s సెకను క్రితం', other: '%s సెకన్ల క్రితం' },
  },
  futureLong: {
    y: { one: '%s సంవత్సరంలో', other: '%s సంవత్సరాల్లో' },
    M: { one: '%s నెలలో', other: '%s నెలల్లో' },
    w: { one: '%s వారంలో', other: '%s వారాల్లో' },
    d: { one: '%s రోజులో', other: '%s రోజుల్లో' },
    h: { one: '%s గంటలో', other: '%s గంటల్లో' },
    m: { one: '%s నిమిషంలో', other: '%s నిమిషాల్లో' },
    s: { one: '%s సెకనులో', other: '%s సెకన్లలో' },
  },
  abbr: {
    y: { one: '%sసం.', other: '%sసంవ.' },
    M: { one: '%sనెల', other: '%sనెలలు' },
    w: { one: '%sవారం', other: '%sవారాలు' },
    d: { one: '%sరోజు', other: '%sరోజులు' },
    h: { one: '%sగంట', other: '%sగంటలు' },
    m: { one: '%sనిమిషం', other: '%sనిమిషాలు' },
    s: { one: '%sసెకను', other: '%sసెకన్లు' },
  },
  full: {
    y: { one: '%s సంవత్సరం', other: '%s సంవత్సరాలు' },
    M: { one: '%s నెల', other: '%s నెలలు' },
    w: { one: '%s వారం', other: '%s వారాలు' },
    d: { one: '%s రోజు', other: '%s రోజులు' },
    h: { one: '%s గంట', other: '%s గంటలు' },
    m: { one: '%s నిమిషం', other: '%s నిమిషాలు' },
    s: { one: '%s సెకను', other: '%s సెకన్లు' },
  },
  justNow: 'ఇప్పుడే',
  yesterday: 'నిన్న',
  today: 'ఈరోజు',
  tomorrow: 'రేపు',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D MMMM, YYYY', end: 'D MMMM, YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM, YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM, YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM, YYYY', end: 'D MMM, YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM, YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM, YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'D MMM, YYYY, ddd', end: 'D MMM, YYYY, ddd' },
    'Y-1': { start: 'D MMM, ddd', end: 'D MMM, YYYY, ddd' },
    M: { start: 'D MMM, ddd', end: 'D MMM, ddd' },
    D: { start: 'D MMM, ddd', end: 'D MMM, ddd' },
    yt: { start: 'D MMM, YYYY HH:mm', end: 'D MMM, YYYY HH:mm' },
    mt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    dt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM, YYYY HH:mm', end: 'D MMM, YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'te';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
